import { $RTKGlobalAPI } from 'shared/store'

import { apiRoutes } from 'shared/config/apiPath/apiPath'

import { SHOP_TAGS_INITIAL_LIMIT } from './const'
import {
  GetBranchesResponse,
  GetServiceCentersResponse,
  GetShopByIdResponse,
  GetShopTagsArgs,
  GetShopTagsResponse,
  GetShopsArgs,
  GetShopsCountResponse,
  GetShopsResponse,
} from './types'

const query = $RTKGlobalAPI.injectEndpoints({
  endpoints: builder => ({
    getShops: builder.query<GetShopsResponse, GetShopsArgs>({
      query: query => ({
        url: apiRoutes.shop.getShops,
        query,
      }),
    }),
    getShopsCount: builder.query<GetShopsCountResponse, void>({
      query: query => ({
        url: apiRoutes.shop.getShopsCount,
        query,
      }),
    }),
    getShopById: builder.query<GetShopByIdResponse, string>({
      query: id => apiRoutes.shop.byId(id),
    }),
    getShopTags: builder.query<GetShopTagsResponse, GetShopTagsArgs>({
      query: params => ({
        url: apiRoutes.shop.getShopTags,
        params,
      }),
    }),
    getServiceCenters: builder.query<GetServiceCentersResponse, string>({
      query: id => ({
        url: apiRoutes.shop.getServiceCenters(id),
      }),
    }),
    getBranches: builder.query<GetBranchesResponse, string>({
      query: id => ({
        url: apiRoutes.shop.getBranches(id),
      }),
      transformResponse: (response: GetBranchesResponse) =>
        response.map(branch => ({
          ...branch,
          pk: branch.id,
          title: branch.name,
        })),
    }),
    getShopTagsScroll: builder.infiniteQuery<
      GetShopTagsResponse,
      GetShopTagsArgs,
      number
    >({
      infiniteQueryOptions: {
        initialPageParam: 0,
        maxPages: 10,
        getNextPageParam: (lastPage, allPages, lastPageParam) => {
          const totalLoaded = allPages.flatMap(p => p.results).length
          const totalAvailable = lastPage.count
          return totalLoaded < totalAvailable ? lastPageParam + 1 : undefined
        },
        getPreviousPageParam: (_, __, firstPageParam) =>
          firstPageParam > 0 ? firstPageParam - 1 : undefined,
      },
      query: ({ queryArg, pageParam }) => ({
        url: apiRoutes.shop.getShopTags,
        params: {
          ...queryArg,
          offset: pageParam * (queryArg.limit || SHOP_TAGS_INITIAL_LIMIT),
        },
      }),
    }),
  }),
})

export const {
  useGetShopTagsQuery,
  useGetShopByIdQuery,
  useGetServiceCentersQuery,
  useGetBranchesQuery,
  useGetShopsQuery,
  useGetShopsCountQuery,
  useGetShopTagsScrollInfiniteQuery,
  endpoints: shopEndpoints,
} = query
